import { useAuth } from "../../contexts/AuthContext";
import React from "react";
import { getAvailablePredefinedFilters } from "../../services/eventService";

const useMenuLogic = () => {
  const { isAuthenticated, user, showAdminPanel } = useAuth();

  const isCurrentPath = (path: string, checkBase: boolean = false) => {
    const currentPath = window.location.pathname;
    return checkBase
      ? currentPath === path
      : currentPath === path || currentPath.startsWith(path + "/");
    // return currentPath === path || currentPath.startsWith(path + "/");
  };

  const [showMyEvents, setShowMyEvents] = React.useState(false);
  const [showManageEvents, setShowManageEvents] = React.useState(false);

  const [showAdminMenu, setShowAdminMenu] = React.useState(false);

  // call fetchPredefinedFilters function if user is authenticated and set showEventAttended and showEventHosted based on the response
  React.useEffect(() => {
    if (isAuthenticated && user) {
      setShowManageEvents(user.is_admin); // Show manage events if user is admin
      fetchPredefinedFilters();
    } else {
      setShowMyEvents(false);
      setShowManageEvents(false);
    }
  }, [isAuthenticated, user]);

  React.useEffect(() => {
    setShowAdminMenu(showAdminPanel);
  }, [showAdminPanel]);

  const fetchPredefinedFilters = async () => {
    try {
      const response = await getAvailablePredefinedFilters();
      const responseFilters = response.data.data.filters;
      setShowMyEvents(
        responseFilters.some((filter: string) => filter === "my-events")
      );
    } catch (error) {
      console.error("Error fetching predefined filters:", error);
      return [];
    }
  };

  return {
    isCurrentPath,
    isAuthenticated,
    showMyEvents,
    showManageEvents,
    showAdminMenu,
  };
};

export default useMenuLogic;
